module.exports = __webpack_public_path__ + "static/media/pepuhernandez_PSOE.c8fd3055.png";